// extracted by mini-css-extract-plugin
module.exports =  {"cooldown":"Emt75IwSRuuT11M3siep","cooldownElement":"Inn0qsBjUeqYX2ZVnTYA","sendingOptionCheckbox":"JYpDVYgJRmK3Lq9xUQn0"};